export default "__VITE_ASSET__Bcn9RIrE__"